export default {"src":"/_next/static/media/pointer.cfe45ab8.svg","height":17,"width":27,"blurWidth":0,"blurHeight":0};